/** @jsx jsx */
import { jsx } from "theme-ui"
import styled from "styled-components"
import theme, { rem } from "@src/theme"

const Radio = ({
  label,
  value,
  name,
  onRadioChange,
  checked,
  onBlur,
  styles,
  variant,
}) => {
  const Component = variant === "tick" ? OuterTick : Outer
  return (
    <div
      sx={{
        bg: "white",
        height: "auto",
        display: "flex",
        alignItems: "center",
        mb: 3,
        borderRadius: "2px",
        width: "100%",
        maxWidth: rem(660),
        ...styles,
      }}
    >
      <Component className="container" label={label}>
        {label}
        <input
          type="radio"
          checked={checked}
          name={name}
          id={name}
          value={value}
          onChange={onRadioChange}
          onBlur={onBlur}
        />
        <div className="checkmark"></div>
      </Component>
    </div>
  )
}

export default Radio

const Outer = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  font-size: 18px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &:focus-within {
    outline: 2px solid ${theme.colors.purple};
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .checkmark {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    border: 2px solid ${theme.colors.darkPurple};
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    margin-top: 3.25px;
  }

  input:checked ~ .checkmark {
    border-color: ${theme.colors.darkPurple};
    background: white;
    &:after {
      content: "";
      display: block;
      position: absolute;
      height: 10px;
      width: 10px;
      background: ${theme.colors.darkPurple};
      border-radius: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  input:checked ~ .checkmark:after {
    display: block;
  }
`
const OuterTick = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  font-size: 18px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &:focus-within {
    outline: 2px solid ${theme.colors.purple};
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .checkmark {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    border: 2px solid ${theme.colors.darkPurple};
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    margin-top: 3.25px;
  }

  input:checked ~ .checkmark {
    border-color: ${theme.colors.darkPurple};
    background: white;
    &:after {
      display: block;
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none"><path d="M5.20906 10.1691L2.00005 7L0 8.99983L5.21347 14L16 2.00003L13.9815 0L5.20906 10.1691Z" fill="%233A2A55"/></svg>');
      position: absolute;
      border-radius: 50%;
      top: 50%;
      left: 50%;
      content: "";
      height: 12px;
      width: 14px;
      transform: translate(-50%, -50%);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
`
